export const teamManagement = {
  forbidden: {
    title: "وصول مقيّد",
    desc: "يمكن للمضيف الرئيسي فقط إدارة الفريق.",
  },
  header: {
    title: "إدارة الفريق",
    subtitle: "تحكّم في من يمكنه الوصول إلى لوحة تحكم مكان إقامتك",
    addMember: "إضافة عضو",
  },
  stats: {
    totalTeam: "إجمالي الفريق",
    host: "المضيف",
    additionalMembers: "أعضاء إضافيون",
  },
  search: {
    placeholder: "ابحث بالاسم أو البريد الإلكتروني…",
  },
  loading: "جارٍ تحميل الفريق…",
  table: {
    member: "العضو",
    email: "البريد الإلكتروني",
    role: "الدور",
    properties: "العقارات",
    added: "تاريخ الإضافة",
    actions: "الإجراءات",
    ownerBadge: "المضيف",
    mainHost: "المضيف الرئيسي",
    viewPermissions: "عرض الوظائف المسموح بها",
    allProperties: "الكل",
    unassigned: "غير معيّن",
    notEditable: "غير قابل للتعديل",
    edit: "تعديل",
    delete: "حذف",
  },
  surfaces: {
    web: "الويب",
    app: "التطبيق",
  },
  empty: {
    title: "لا يوجد أعضاء إضافيون",
    desc: "استخدم زر <strong>إضافة عضو</strong> لدعوة أشخاص إلى فريقك.",
  },
  infoBanner:
    "يصل أعضاء الفريق إلى اللوحة باسم مستخدم وكلمة مرور خاصين بهم. لكل ملف صلاحيات ثابتة، ويُقيَّد الوصول إلى البيانات من الخادم. المالك يدخل عبر الويب فقط؛ أما التنظيف والصيانة فعبر التطبيق فقط. يمتلك <strong>المضيف الرئيسي</strong> دائمًا وصولًا كاملًا ولا يمكن حذفه.",
  modal: {
    createTitle: "إضافة عضو",
    editTitle: "تعديل عضو",
    nameLabel: "الاسم الكامل",
    namePlaceholder: "مثال: أحمد محمد",
    emailLabel: "البريد الإلكتروني",
    emailPlaceholder: "email@example.com",
    roleLabel: "ملف الوصول",
    viewScope: "عرض النطاق",
    accessIncluded: "الوصول المتضمَّن",
    assignedProperties: "العقارات المعيّنة",
    selectedCount: "({selected} من {total} محدّدة)",
    propertySearchPlaceholder: "ابحث عن عقار…",
    selectAll: "تحديد الكل",
    clear: "مسح",
    noResults: 'لا نتائج لـ "{query}"',
    selectAtLeastOneHint: "اختر عقارًا واحدًا على الأقل لهذا الملف.",
    noPropertiesWarning:
      "لا توجد عقارات متاحة للتعيين. أنشئ عقارًا قبل حفظ هذا الملف.",
    passwordLabel: "كلمة المرور",
    passwordOptional: "(اتركه فارغًا لعدم التغيير)",
    passwordPlaceholder: "8 أحرف على الأقل",
    confirmPasswordLabel: "تأكيد كلمة المرور",
    confirmPasswordPlaceholder: "أعد إدخال كلمة المرور",
    showPassword: "إظهار كلمة المرور",
    hidePassword: "إخفاء كلمة المرور",
    cancel: "إلغاء",
    create: "إنشاء عضو",
    save: "حفظ التغييرات",
  },
  deleteModal: {
    title: "حذف عضو",
    subtitle: "لا يمكن التراجع عن هذا الإجراء",
    confirm:
      "هل أنت متأكد أنك تريد حذف {name} من الفريق؟ سيفقد الوصول إلى اللوحة فورًا.",
    cancel: "إلغاء",
    delete: "حذف",
  },
  roleInfo: {
    defaultTitle: "الصلاحيات",
    description:
      "هذا الملف ثابت. يُتحقَّق أيضًا من نطاقه وسطح وصوله وعقاراته على الخادم.",
    understood: "فهمت",
  },
  roleDescriptions: {
    anfitrion: "وصول كامل إلى جميع العقارات من الويب والتطبيق.",
    propietario: "التقويمات والتحليلات للعقارات المعيّنة فقط. وصول عبر الويب.",
    limpieza: "بدء التنظيف والمهام والرسائل الخاصة بعقاراته. عبر التطبيق فقط.",
    mantenimiento:
      "بدء الصيانة والمهام والرسائل الخاصة بعقاراته. عبر التطبيق فقط.",
    fallback: "ملف توافق بوصول مقيّد.",
  },
  optionalHints: {
    messages:
      "عرض محادثات عقاراته والرد عليها. عند التعطيل، لن يرى الرسائل ولن يتلقّى إشعاراتها.",
  },
  toasts: {
    loadError: "تعذّر تحميل الفريق.",
    memberAdded: "✓ تمت إضافة العضو إلى الفريق.",
    memberUpdated: "✓ تم تحديث العضو.",
    saveError: "تعذّر الحفظ. حاول مرة أخرى.",
    memberDeleted: "تم حذف العضو من الفريق.",
    deleteError: "تعذّر حذف العضو.",
  },
};
